export default __webpack_public_path__ + "static/media/portal-admin-user.241eb3f7.svg";